import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Row,Col} from 'react-bootstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

class Edit extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'UPDATE UNIVERSITY',
			isRedirect: false,
			showLoader: false,
			editData: this.props.editData,
			country: '',
			region: ''
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}
	
	selectCountry (val) {
		this.setState({ country: val });
	}
	 
	selectRegion (val) {
		this.setState({ region: val });
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		this.setState({showLoader:true,saveText:'Updating..'});
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('university/updateuniversity',{token: Reqst.Token(formData)}).then(res=>{
			if(res['data'].status=='1')
			{
				notify.show(res['data'].msg,'success');
				this.setState({showLoader:false,saveText:'UPDATE UNIVERSITY'});
				if(this.props.afterFinish) this.props.afterFinish();
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false,saveText:'UPDATE UNIVERSITY'});
			}
		});
	}
	
	getData(field){
		var l = this.state.editData;
		return l[field];
	}
	
	setData(field,e){
		var l = this.state.editData;
		l[field] = e.target.value;
		this.setState({editData: l });
	}
	
	render(){
		
		const { country, region } = this.state;

		return(
			<div>			
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__id" value={this.getData('id')} />
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>University Name <span className="text-danger">*</span></label>
							<input type="text" name="i__name" id="i__name" className="form-control input-sm" required value={this.getData('universityname')} onChange={this.setData.bind(this,'universityname')} />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>City </label>
							<input type="text" name="i__city" id="i__city" className="form-control input-sm" value={this.getData('city')} onChange={this.setData.bind(this,'city')} />
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<label>Country</label>
							<CountryDropdown className="form-control input-sm"  value={country == '' ? this.getData('country') : country} onChange={(val) => this.selectCountry(val)} />
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<label>State</label>
							<RegionDropdown className="form-control input-sm"  country={country == '' ? this.getData('country') : country} value={region == '' ? this.getData('state') : region} onChange={(val) => this.selectRegion(val)} />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Contact No </label>
							<input type="text" onKeyPress={Sanitize.integerIndMobile} name="i__mobile" id="i__mobile" className="form-control input-sm" value={this.getData('mobile')} onChange={this.setData.bind(this,'mobile')} />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Active Status <span className="text-danger">*</span></label>
							<select name="i__status" id="i__status" className="form-control input-sm" required >
								<option value="1" selected={this.getData('categorystatus')=='1' ? 'selected' : ''} > Active </option>
								<option value="0" selected={this.getData('categorystatus')=='0' ? 'selected' : ''}  > In Active </option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText!='UPDATE UNIVERSITY'} >
									<i className="fa fa-check"></i> {this.state.saveText} 
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}
	
}
export default Edit;